export function getElementIndex(el: HTMLElement): number {
    return [ ... el.parentElement.children].indexOf(el);
}
